import { createAction, props } from '@ngrx/store';

import { type } from '@app/util/util';
import {
  AssistanceBookPayload, AssistanceSearchPayload, AssistanceSearchResponse,
  AssistanceCancellationPayload, AssistanceConvertPdfPayload
} from '@shared/travel-assistance/entities/booking-assistance';
import { CancellationState } from '@shared/travel-assistance/entities/assistance-cancellation';
import { TravelBookingType } from '@pax/entities/travel-booking-types';

export const fetchAssistanceSearchAction = createAction(
  type('[Assistance/API] Fetch assistance search'),
  props<{ payload: AssistanceSearchPayload, bookingType: TravelBookingType }>()
);
export const fetchAssistanceSearchByCrossSellingAction = createAction(
  type('[Assistance/API] Fetch assistance search by cross selling'),
  props<{ payload: AssistanceSearchPayload }>()
);
export const fetchAssistanceSearchSuccessAction = createAction(
  type('[Assistance/API] Fetch assistance search success'),
  props<{ response: AssistanceSearchResponse }>()
);
export const fetchAssistanceSearchErrorAction = createAction(
  type('[Assistance/API] Fetch assistance search error')
);
export const fetchAssistanceBookAction = createAction(
  type('[Assistance/API] Fetch assistance book'),
  props<{ payload: AssistanceBookPayload }>()
);
export const fetchAssistanceBookErrorAction = createAction(
  type('[Assistance/API] Fetch assistance book error')
);
export const closeAssistanceInfoSuccessAction = createAction(
  type('[Assistance/UI] Close assistance info success')
);
export const setShowAssistanceDetailsAction = createAction(
  type('[Assistance/UI] Set show assistance details'),
  props<{ payload: boolean }>()
);
export const resetAssistanceSearchInfoAction = createAction(
  type('[Assistance/UI] Reset assistance search info')
);
export const fetchAssistanceCancellationAction = createAction(
  type('[Assistance/API] Fetch assistance cancellation'),
  props<{ payload: AssistanceCancellationPayload }>()
);
export const fetchAssistanceCancellationSuccessAction = createAction(
  type('[Assistance/API] Fetch assistance cancellation success'),
  props<{ cancellationState: CancellationState }>()
);
export const fetchAssistanceCancellationErrorAction = createAction(
  type('[Assistance/API] Fetch assistance cancellation error')
);
export const fetchAssistanceConvertPdfAction = createAction(
  type('[Assistance/API] Fetch assistance convert pdf'),
  props<{ payload: AssistanceConvertPdfPayload }>()
);
export const fetchAssistanceConvertPdfSuccessAction = createAction(
  type('[Assistance/API] Fetch assistance convert pdf success'),
  props<{ url: string }>()
);
export const cancelAssistanceConvertPdfAction = createAction(
  type('[Assistance/API] cancel assistance convert pdf')
);
export const fetchAssistanceConvertPdfActionError = createAction(
  type('[Assistance/API] fetch assistance convert pdf error')
);
export const toggleShowAssistanceInfoAction = createAction(
  type('[Assistance/API] Show assistance info'),
  props<{ payload: boolean }>()
);

